module.exports = require("strip-ansi");


//////////////////
// WEBPACK FOOTER
// external "strip-ansi"
// module id = 18
// module chunks = 0